import Image from 'next/image';
import AccordionText from '../Utils/AccordionText';


const Faq = () => {

  const title_style = "text-[#2C3E2F] font-dmsans text-lg font-bold -tracking-[0.9px]";
  const desc_style = "font-dmsans font-normal text-base text-[#2C3E2F] leading-8 -tracking-[0.8px]"

  return (
    <>
      <div className="md:container">
        <div className="relative hidden w-full md:block">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/faq-desktop.jpg"}
            alt="FAQ image"
            width={1800}
            height={422}
            quality={100}
          />
          <h1 className="absolute text-5xl text-white font-dmsans font-medium -tracking-[2.4px] top-1/2 -translate-y-1/2 pl-[104px]">
            FAQ
          </h1>
        </div>
        <div className="w-full md:hidden">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/faq-mobile.jpg"}
            alt="FAQ image"
            width={900}
            height={600}
            quality={100}
          />
        </div>
      </div>
      <div className="container flex justify-center mt-12 mb-20">
        <div className="w-full md:w-[680px] font-dmsans text-[#2C3E2F]">
          <AccordionText
            title="How long will my order arrive?"
            title_style={title_style}
            description="We usually deliver your order within 3 to 10 business days, excludes weekends and holidays."
            desc_style={desc_style}
          />
          <AccordionText
            title="Can I modify or cancel my order?"
            title_style={title_style}
            description="Once you've completed the payment, we're unable to make changes to your orders. However, you can contact us via email to inquire about the status of your order."
            desc_style={desc_style}
          />
          <AccordionText
            title="I haven't received my order. How can I track them?"
            title_style={title_style}
            description="Use the tracking number you have received to check the status of your package. If you haven't received a tracking number or are having trouble, please get in touch with us via email."
            desc_style={desc_style}
          />
          <AccordionText
            title="My order was marked as delivered but I didn't receive them. What should I do?"
            title_style={title_style}
            description="If your order is marked as delivered but you haven't received it, follow these steps:<br />
            <div className='pl-4 list-decimal'>
              <li>Contact the delivery courier for more information about the delivery.</li>
              <li>Please email us at cs@green-parenting.com to report the issue.</li>
            </div>
            "
            desc_style={desc_style}
          />
          <AccordionText
            title="Do you ship to my country?"
            title_style={title_style}
            description="You can find detailed information about our return and exchange policies on our dedicated &quot;<a href='/delivery-information' style='text-decoration-line: underline;'>DELIVERY INFORMATION</a>&quot; page."
            desc_style={desc_style}
          />
          {/* <AccordionText
            title="Can I exchange a product?"
            title_style={title_style}
            description="Product exchange is allowed under the following conditions, except for briefs (underwear), and in the following situations:
            <div className='pl-4 list-disc'>
              <li>Products received in a defective and/or damaged condition.</li>
              <li>Products received that do not match the order (e.g., wrong size, color, etc.).</li>
              <li>The exchange period is limited to 7 days after the receipt of the item.</li>
              <li>One exchange per product is the maximum limit.</li>
              <li>Products intended for exchange must meet the following requirements: the price tag should be intact, the product should not have been washed, it should not have been worn (only tried on once for fitting), the packaging should be complete, and there should be no alterations to the product.</li>
            </div>
            <p style='color: #E85365;'>** The definition of damaged products includes defects caused by manufacturing.</p>
            <p style='color: #E85365;'>** Product exchanges must be made with the same unit and size/color. The availability of replacement products depends on stock availability.</p>
            <p style='color: #E85365;'>** If replacement product stock is unavailable, Green Parenting Customer Service will confirm with the customer again.</p>"
            desc_style={desc_style}
          /> */}
          {/* <AccordionText
            title="Can I return my order?"
            title_style={title_style}
            description="You can find detailed information about our return and exchange policies on our dedicated &quot;<a href='/return-and-exchange' style='text-decoration-line: underline;'>Return and Exchange</a>&quot; page."
            desc_style={desc_style}
          /> */}
          {/* <AccordionText
            title="Is there any other refund options available?"
            title_style={title_style}
            description="The supported refund option is a refund to the original payment method."
            desc_style={desc_style}
          /> */}
          {/* <AccordionText
            title="Are international customers eligible for free returns?"
            title_style={title_style}
            description="Please note that international orders do not qualify for complimentary return shipping, with the following exceptions: defective items and shipping errors attributable to Green Parenting. Additionally, international deliveries may be subject to import duties and VAT charges, which are not included in your order's total. Green Parenting is not responsible for any import duties or customs fees."
            desc_style={desc_style}
          /> */}
        </div>
      </div>
    </>
  )
}

export default Faq
